module.exports = __webpack_public_path__ + "img/mastermind-white-logo.32fe3f69.svg";